import { render, staticRenderFns } from "./YHK.vue?vue&type=template&id=fb54068a&scoped=true&"
import script from "./YHK.vue?vue&type=script&lang=js&"
export * from "./YHK.vue?vue&type=script&lang=js&"
import style0 from "./YHK.vue?vue&type=style&index=0&id=fb54068a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb54068a",
  null
  
)

export default component.exports